import React, { useState, useEffect } from 'react';

// USAGE:
// <DelayedRender delay={2000}>
//   <img src="path-to-your-image.png"/>
// </DelayedRender>
export const DelayedRender = ({ delayMs = 3000, children }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delayMs);
    return () => clearTimeout(timer);
  }, [delayMs]);

  return show ? <>{children}</> : null;
};
